import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'sobre-page',
  templateUrl: './sobre-page.component.html',
  styleUrls: ['./sobre-page.component.scss']
})
export class SobrePage implements OnInit {

  public loader  = false;
  public apelido = "sobre"; 
  public response = {
    data: "",
    status: null
  }
  public page:any   = {};
  public params:any = {};
  public itensB = [{
    text: "Sobre"
  }];
  public photo = "";
  public valores:any = [];

  constructor(
    private app: AppService,
    private api: ApiService
  ) { }

  /**
   * 
   * Retorna os dados da página
   * 
   */
  getData(){

    try{

      this.loader = true;

      this.api.conteudo().page(this.apelido).subscribe(response => {
        
        this.loader = false;   

        if(response.status == 1){
                
          if(typeof(response.data.page) != "undefined"){
            
            this.response = { 
              data: "",
              status: 1
            }

            this.page      = typeof(response.data.page.data[0]) != "undefined" ? response.data.page.data[0] : response.data.page.data;
            this.params    = this.page.params != null ? JSON.parse(this.page.params) : {};
            this.valores   = response.data.page.valores; 

            this.app.setMetaDados(this.page.meta_title,this.page.meta_description); 
            this.setImage();
              
          }  
      
      
        }else{
          this.response = {
            data: response.data,
            status: 500
          }
        }
        this.app.toTop(); 

      },(response) => {

        this.loader = false;
        this.app.toTop(); 
        
      
      });

    }catch(e){

      this.loader = false;

    }

  }
  /***
   * 
   * Image
   * 
   */
   setImage(){

    this.photo = "/images/modulo/visao/"+this.params.imagem;

  }
  /**
   * 
   * Inicilaiza as Funções
   * 
   */
  ngOnInit():void{
    this.getData();
  }

}
